/**
 * Whether the pill composer draws its controls under the text (P5 „Pisanie") rather than beside it.
 *
 *   · past one line it takes the whole width, and stays so while there is text: going back on every
 *     narrower measure would make the box jump while the trainer types
 *   · emptied, it is one line again
 *   · never in the builder's `panel` layout, whose field starts at two lines and has no pill to rearrange
 *   · never for an empty field, whatever the measure says: a placeholder that wraps must not flip the
 *     layout, which re-measures and flips it back (the builder panel's `Maximum update depth exceeded`)
 *
 * `wraps` is the latest measure; a render with no new measure passes `false`.
 */
export function composerWraps(
  previous: boolean,
  { wraps, layout, text }: { readonly wraps: boolean; readonly layout: 'hero' | 'dock' | 'panel'; readonly text: string },
): boolean {
  if (layout === 'panel' || text === '') return false;
  return previous || wraps;
}
